<template>
  <span :class="$style.wrapper">
    <span :class="$style['input-wrapper']">
      <ds-search-icon />
    </span>
    <form
      action=""
      @submit.prevent="onEnter"
    >
      <input
        v-model="searchPhrase"
        :placeholder="placeholder"
        type="text"
      >
    </form>
  </span>
</template>

<script>
export default {
  name: "DsSearchInput",
  props: {
    placeholder: {
      type: String,
      default: "Szukaj"
    }
  },
  data() {
    return {
      searchPhrase: ""
    };
  },
  watch: {
    searchPhrase(value) {
      this.$emit("onChange", value);
    }
  },
  methods: {
    onEnter() {
      this.$emit("enterTrigger", this.searchPhrase);
      this.searchPhrase = "";
    }
  }
};
</script>

<style lang="scss" module>
@import "../../scss/_variables.scss";
@import "../../scss/_mixins.scss";

.wrapper {
  position: relative;
  display: flex;
  flex-basis: 430px;
  @include mobile() {
    flex-basis: initial;
    width: 100%;
    margin-top: 15px;
  }
  input[type="text"] {
    border-radius: 5px;
    background-color: #f0f4fa;
    border: none;
    height: $input-height;
    outline: none;
    padding: 0px 10px;
    font-size: $font-small-size;
    width: 100%;
    box-shadow: none;
    color: $light-gray-color;
    &:active,
    &:focus {
      box-shadow: none !important;
    }
    padding-left: 25px;
    font-weight: 300;
    line-height: 16px;
  }
}
.input-wrapper {
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  left: 2px;
  width: 15px;
  height: 15px;
  transform: translateY(-50%);
  > span {
    margin: 0px;
  }
  svg {
    height: 1.1em;
    @include smallMobile() {
      height: 15px;
      margin-left: 4px;
    }
  }
}

::-webkit-input-placeholder,
:-moz-placeholder,
::-moz-placeholder,
:-ms-input-placeholder {
  color: $light-gray-color;
}
</style>



// WEBPACK FOOTER //
// ../panel-theme/src/js/widgets/ds-search-input.vue